<template>
    <div class="Rack-Box mt-3 mb-5">
        <b-form>
            <b-row>
                <b-col>
                    <div class="field">
                        <CustomDropdown label="Rack" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="field">
                        <CustomDropdown label="Box" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="field">
                        <TextField name="" label="Re-Order Level" />
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <div class="field">
                        <Footer />
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
    
<script lang="ts">
import { defineComponent } from 'vue'
import TextField from '../../../../../../components/FormComponents/TextInput.vue'
import CustomDropdown from '../../../../../../components/FormComponents/Dropdown.vue'
import Footer from '../../../../../../components/FormComponents/Footer.vue'
export default defineComponent({
    components: {
        TextField,
        CustomDropdown,
        Footer
    },
    setup() {
        return {

        }
    }

})
</script>
    
<style lang="scss" scoped>
.Rack-Box {
    .n-card {
        background-color: #fafafa;
        max-width: 300px;
    }
}
</style>